"use client"

import Image from "next/image"
import Link from "next/link"
import { ROUTES } from "@/config/routes"
import { HomeSection } from "./HomeSection"
import { StaggerContainer, StaggerItem } from "@/components/animations"

type ServiceCardType = {
  title: string
  description?: string
  image: string
  url: string
}

const services: ServiceCardType[] = [
  {
    title: "Maximiza tu productividad con las Soluciones Digitales Cat",
    image: "/images/home/soluciones-digitales.webp",
    url: ROUTES.solutions.addedValueCat.digitalTools.root,
  },
  {
    title: "DA UNA SEGUNDA VIDA A TU EQUIPO con nuestras Reconstrucciones Certificadas Cat",
    image: "/images/home/reconstruc-certificadas.webp",
    url: ROUTES.partsServices.details("servicios/reconstrucciones-certificadas-cat"),
  },
  {
    title: "SIGNOS VITALES DE TU EQUIPO EN CADA MUESTRA con nuestro servicio de Análisis de Fluidos (S.O.S)",
    image: "/images/home/analisis-de-fluidos.webp",
    url: ROUTES.partsServices.details("servicios/sos-analisis-de-fluidos"),
  }
]

const ServiceCard = ({ service }: { service: ServiceCardType }) => (
  <Link
    href={service.url}
    className="block h-full w-full group"
  >
    {/* Mobile version */}
    <div className="sm:hidden flex bg-dark01 h-[120px] overflow-hidden p-2 space-x-2 transition-all duration-300 hover:scale-[1.02] ">
      <div className="relative w-[120px] h-full overflow-hidden rounded-md">
        <Image
          fill
          className="object-cover transition-transform duration-300 group-hover:scale-105"
          src={service.image}
          alt={service.title}
        />
      </div>
      <div className="flex-1 flex flex-col justify-center">
        <h3 className="text-base font-bold uppercase text-white">{service.title}</h3>
        <p className="text-sm mt-2 text-white/60 line-clamp-2">{service.description}</p>
      </div>
    </div>

    {/* Desktop version */}
    <div className="hidden sm:flex flex-col rounded-lg overflow-hidden bg-dark01 cursor-pointer h-full transition-all duration-500 hover:scale-[1.03] hover:-translate-y-2 ">
      <div className="relative w-full flex-shrink-0 overflow-hidden" style={{ aspectRatio: '366/345' }}>
        <Image
          fill
          className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-105"
          src={service.image}
          alt={service.title.toLowerCase()}
        />
      </div>
      <div className="flex flex-col justify-start items-center text-center py-6 px-8 space-y-2 flex-grow">
        <div>
          <h3 className="text-lg lg:text-xl font-bold uppercase inline text-white">{service.title}</h3>
          {service.description && (
            <p className="text-sm lg:text-base inline ml-1 text-white/80">{service.description}</p>
          )}
        </div>
      </div>
    </div>
  </Link>
)

export const Service = () => {
  return (
    <HomeSection
      title="SERVICIOS"
      viewAllLink={ROUTES.partsServices.details("/servicios")}
      className="bg-stone"
      titleColor="text-white"
    >
      <StaggerContainer staggerDelay={0.15} className="flex flex-col sm:grid sm:grid-cols-3 gap-4">
        {services.map((service, index) => (
          <StaggerItem key={index}>
            <ServiceCard service={service} />
          </StaggerItem>
        ))}
      </StaggerContainer>
    </HomeSection>
  )
}